export default {"src":"/kelp/_next/static/media/tacBtc.70b57e63.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};